/* eslint-disable @next/next/no-img-element */
import { useState } from "react";
import { HiChevronRight, HiChevronLeft } from "react-icons/hi2";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Image from "next/legacy/image";
import Link from "next/link";
import classNames from "classnames";
import PropTypes from "prop-types";
import Styles from "./index.module.scss";
import { useDeviceType } from "@/hooks/useDeviceType";
import MobileHomeCarousel from "@/components/Carousel/mobileHomeCarousel";
import { getLinkTarget } from "@/utils/helper";

const CarouselComponent = ({ carouselData }) => {
  const [clicked, setClicked] = useState(null);
  const [count, setCount] = useState(0);
  const { isMobile, width } = useDeviceType();
  if (width === null) return null;
  const carouselItem = carouselData?.carouselItem ?? [];
  const size = carouselData?.size;
  let startX = 0;
  const {
    fields: {
      showOnlyForHomePage = false,
      heading = "",
      paragraph = "",
      internalUrl = "",
      textColor = "black",
      ctaTextColor = null,
      alignment = "",
      cta: [{ fields: { label: ctaLabel = "" } = {} } = {}] = [],
      mobileCta: [{ fields: { label: mobilectaLabel = "" } = {} } = {}] = [],
      mediaItem: [
        {
          fields: {
            asset: {
              fields: { countBasedTitle = "", countBasedDesc = "" } = {},
            } = {},
            externalUrl: countExternalUrl = "",
          } = {},
        } = {},
      ] = [],
      countBasedUrl = "",
    } = {},
  } = carouselItem?.[count] ?? {};

  if (width === null) return null;
  const showForHomePageMobileView = isMobile & showOnlyForHomePage;

  let ctaColors =
    ctaTextColor === undefined || ctaTextColor === null
      ? textColor
      : ctaTextColor;

  let centerCarouselClass = size === "Centered" ? "centerCarousel" : "w-full";

  let bannerHeight = showForHomePageMobileView
    ? "max-md:h-[500px]"
    : carouselItem?.length > 1
      ? "max-md:h-[280px]"
      : "max-md:h-[139px]";

  const homePageOnlyClass = showForHomePageMobileView ? "homePageOnly" : "";
  const imageElement = ({ url, imageUrl, altText, imageHeight }) => {
    return (
      <div
        onMouseDown={e => e.preventDefault()}
        className={`select-none lg:relative !w-[-webkit-fill-available] lg:inline-block ${bannerHeight}`}
      >
        <img
          src={url || imageUrl}
          className={`text-black select-none pointer-events-none ${bannerHeight} ${homePageOnlyClass}`}
          alt={altText}
          width="100%"
          height={imageHeight}
          draggable={false}
          onDragStart={e => e.preventDefault()}
          onMouseDown={e => e.preventDefault()}

          // priority
        />
        {(heading || paragraph) && (
          <div
            className={`!flex flex-col items-center justify-center banner-text lg:block hidden !font-['HelveticaRoman', Helvetica, sans-serif] ${textColor === "white" ? "!text-white" : "!text-[#000]"} leading-tight`}
          >
            {heading && (
              <h1
                className={`max-[1024px]:hidden !text-[40px] !leading-[57.1429px] !font-[400] ${textColor === "white" ? "!text-white" : "!text-[#000]"} !font-['HelveticaRoman',_Helvetica,_sans-serif]`}
              >
                {heading}
              </h1>
            )}
            {paragraph && (
              <p
                className={`max-[1024px]:hidden !mt-[30px] !mb-[35px] !font-[400] ${textColor === "white" ? "!text-[#FFFFFF]" : "!text-[#000000]"} !font-['HelveticaRoman',_Helvetica,_sans-serif] !text-[18px] font-normal`}
              >
                {paragraph}
              </p>
            )}

            {ctaLabel && (
              <p
                className={`max-[1024px]:hidden uppercase p-[9px] border-[0.5px] border-black !mt-[15px] !font-[600] ${ctaColors === "white" ? "!text-[#FFFFFF]" : "!text-[#000000]"} !font-[HelveticaRoman, Helvetica, sans-serif] !text-[14px] w-[200px] hover:bg-[#607ca1] hover:!text-[#fff] transition-colors duration-300`}
              >
                {ctaLabel}
              </p>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`${centerCarouselClass} ${Styles.carouselWrapper}`}>
      {showForHomePageMobileView ? (
        <MobileHomeCarousel carouselItem={carouselItem} />
      ) : (
        <Carousel
          emulateTouch={!showForHomePageMobileView}
          centerMode={false}
          showThumbs={false}
          infiniteLoop={true}
          autoPlay={true}
          swipeable={!showForHomePageMobileView}
          showStatus={false}
          interval={5000}
          showIndicators={carouselItem?.length > 1}
          dynamicHeight={true}
          onChange={id => setCount(id)}
          animationHandler="slide"
          axis="horizontal"
          transitionTime={800}
          className="overflow-hidden relative"
          renderArrowPrev={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button
                type="button"
                onClick={() => {
                  onClickHandler();
                  setClicked(true);
                }}
                // className={classNames("dp-left-arrow", { clicked: clicked })}
                className="slick-style-arrow arrow-position-left"
              >
                {/* <HiChevronLeft size={55} /> */}
              </button>
              // <span className="carousel-icon"></span>
            )
          }
          renderArrowNext={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button
                type="button"
                onClick={() => {
                  onClickHandler();
                  setClicked(true);
                }}
                className="slick-style-arrow arrow-position-right"
              >
                <HiChevronRight size={55} />
              </button>
            )
          }
        >
          {carouselItem?.map(item => {
            const {
              fields: {
                heading = "",
                paragraph = "",
                internalUrl = "",

                // cta: [{ fields: { label: ctaLabel = "" } = {} } = {}] = [],
                ["mediaItem"]: [
                  {
                    fields: {
                      asset: {
                        fields: {
                          file: {
                            url = "",
                            details: {
                              // image: { width = 0, height = 0 } = {},
                            } = {},
                          } = {},
                          title = "",
                          description = "",
                        } = {},
                      } = {},
                      externalUrl = "",
                      imageUrl = "",
                      imageWidth = 2000,
                      imageHeight = 672,
                      altText = "",
                    } = {},
                  } = {},
                ] = [],
              } = {},
            } = item ?? {};

            let linkTarget = "_self";

            if (externalUrl) {
              linkTarget = "_blank";
            } else if (internalUrl) {
              linkTarget = getLinkTarget(internalUrl);
            }
            return externalUrl || internalUrl ? (
              // <Link
              //   href={externalUrl || internalUrl}
              //   key={item?.sys?.id}
              //   target={externalUrl ? "_blank" : "_self"}
              //   rel={externalUrl ? "noopener noreferrer" : ""}
              //   className="block cursor-pointer"
              // >
              //   {imageElement({
              //     url,
              //     imageUrl,
              //     altText,
              //     imageHeight,
              //   })}
              // </Link>

              <Link
                href={externalUrl || internalUrl}
                key={item?.sys?.id}
                target={linkTarget}
                rel={externalUrl ? "noopener noreferrer" : ""}
                className="block cursor-pointer dddd"
                onPointerDown={e => {
                  startX = e.clientX;
                  e.currentTarget.dataset.drag = "false";
                }}
                onPointerMove={e => {
                  if (Math.abs(e.clientX - startX) > 10) {
                    e.currentTarget.dataset.drag = "true";
                  }
                }}
                onClick={e => {
                  if (e.currentTarget.dataset.drag === "true") {
                    e.preventDefault(); // ✅ prevents navigation on drag
                  }
                }}
              >
                {imageElement({
                  url,
                  imageUrl,
                  altText,
                  imageHeight,
                })}
              </Link>
            ) : (
              imageElement({
                url,
                imageUrl,
                altText,
                imageHeight,
              })
            );
          })}
        </Carousel>
      )}

      {/* Carousel banner mobile */}
      {(heading || paragraph) && (
        <div className="bg-[#e3e3e3] flex flex-col items-center text-[#000] lg:hidden leading-tight p-[20px]">
          <h1 className="!font-[600] font-[HelveticaRoman, Helvetica, sans-serif] text-[34.29px] text-center text-[#000]">
            {heading}
          </h1>
          <p className="!font-[500] font-[HelveticaRoman, Helvetica, sans-serif] mt-[15px] mb-[10px] text-[21.28px] text-center">
            {paragraph}
          </p>
          {ctaLabel && (
            <a
              href={countExternalUrl || internalUrl || undefined}
              target={countExternalUrl ? "_blank" : "_self"}
              rel={countExternalUrl ? "noopener noreferrer" : ""}
              className={`m-0 outline-none bg-white inline-block px-[20px] py-[13.5px] border-0 rounded-[4px] shadow-[0_2px_2px_0_rgba(0,0,0,0.2)] font-[HelveticaBold,Helvetica,sans-serif] leading-[1em] font-normal uppercase no-underline text-center !mt-[15px] !font-[600] ${textColor === "white" ? "!text-white" : "!text-[#000]"} max-lg:!text-[#000] !font-[HelveticaRoman, Helvetica, sans-serif] !text-[14px]`}
            >
              {ctaLabel}
            </a>
          )}
          {countBasedUrl && (
            <Link href={countBasedUrl} target="_blank" legacyBehavior>
              <button className="bg-[#fff] px-4 py-3 text-[12px] rounded-md uppercase shadow-lg mt-[15px] font-HelveticaBold">
                Browse
              </button>
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

CarouselComponent.propTypes = {
  carouselData: PropTypes.shape({
    size: PropTypes.string,
    carouselItem: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          url: PropTypes.string,
          mediaItem: PropTypes.arrayOf(
            PropTypes.shape({
              fields: PropTypes.shape({
                asset: PropTypes.shape({
                  fields: PropTypes.shape({
                    file: PropTypes.shape({
                      url: PropTypes.string,
                    }),
                    altText: PropTypes.string,
                    title: PropTypes.string,
                    description: PropTypes.string,
                  }),
                }),
              }),
            })
          ),
        }),
        sys: PropTypes.shape({
          id: PropTypes.string,
        }),
      })
    ),
  }),
  showBanner: PropTypes.bool,
};

CarouselComponent.defaultProps = {
  showBanner: true,
  carouselData: {
    size: "",
    carouselItem: [],
  },
};

export default CarouselComponent;
